import React from "react";
import { useTranslation } from "react-i18next";
import { useChatContext } from "./chat_context.jsx";

export default function ChatSettingsSidebar() {
  const { t } = useTranslation("labels");
  
  const {
    showSettings,
    setShowSettings,
    groundingFolders,
    headerHeight,
    selectedGroundingFolders,
    toggleGroundingFolder,
    selectAllGroundingFolders,
    clearGroundingFolders,
  } = useChatContext();

  // Handle select all / deselect all
  const handleSelectAll = () => {
    if (selectedGroundingFolders.length === groundingFolders.length) {
      clearGroundingFolders();
    } else {
      selectAllGroundingFolders();
    }
  };

  return (
    <div
      className={`position-fixed d-flex flex-column bg-white border-start border-secondary shadow ${showSettings ? "end-0" : "end-n5"}`}
      style={{
        top: `${headerHeight}px`,
        height: `calc(100vh - ${headerHeight}px)`,
        width: "350px",
        zIndex: 1051,
        transition: "right 0.3s ease-in-out",
        right: showSettings ? "0" : "-350px"
      }}
    >
      <div className="d-flex justify-content-between align-items-center p-3 border-bottom bg-light">
        <h5 className="mb-0">{t("settings", { ns: "labels" })}</h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => setShowSettings(false)}
          aria-label="Close"
        ></button>
      </div>
      <div
        className="flex-grow-1"
        style={{ overflowY: "auto", padding: "1rem" }}
      >
        <div className="row g-3">
          <div className="col-12">
            <label className="form-label">
              {t("aIProfile", { ns: "labels" })}
            </label>
            <select id="ai-tutor" className="form-select">
              <option value="AI_PLAN">AI Plan document expert</option>
              <option value="ANNA_DOCUMENT_QUALITY">
                ANNA document quality tutor
              </option>
              <option value="ANNA">ANNA AI tutor</option>
              <option value="ANNA_DOCUMENT">ANNA document writer</option>
            </select>
          </div>
          <div className="col-12">
            <label className="form-label">
              {t("grounding", { ns: "labels" })}
              <span className="text-muted ms-1">
                ({selectedGroundingFolders.length}/{groundingFolders.length})
              </span>
            </label>
            
            {/* Select All / Deselect All button */}
            {groundingFolders.length > 0 && (
              <div className="mb-2">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={handleSelectAll}
                >
                  {selectedGroundingFolders.length === groundingFolders.length 
                    ? t("deselectAll", { ns: "labels" }) 
                    : t("selectAll", { ns: "labels" })}
                </button>
              </div>
            )}
            
            {/* Grounding folders checkboxes */}
            <div className="border rounded p-2" style={{ maxHeight: "200px", overflowY: "auto" }}>
              {groundingFolders.length === 0 ? (
                <div className="text-muted fst-italic">
                  {t("noGroundingFolders", { ns: "labels" })}
                </div>
              ) : (
                groundingFolders.map((folder) => (
                  <div key={folder.Id} className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`grounding-${folder.Id}`}
                      checked={selectedGroundingFolders.includes(folder.Id)}
                      onChange={() => toggleGroundingFolder(folder.Id)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`grounding-${folder.Id}`}
                      title={folder.Name}
                    >
                      {folder.Name}
                    </label>
                  </div>
                ))
              )}
            </div>
            
            {/* Show selected folders count */}
            {selectedGroundingFolders.length > 0 && (
              <small className="text-muted mt-1 d-block">
                {t("selectedFolders", { ns: "labels", count: selectedGroundingFolders.length })}
              </small>
            )}
          </div>
        </div>
      </div>
      <div className="p-3 border-top bg-light">
        <button
          type="button"
          className="btn btn-primary w-100"
          onClick={() => setShowSettings(false)}
        >
          {t("save", { ns: "labels" })}
        </button>
      </div>
    </div>
  );
}

